var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialsInner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.875 1.87501C11.4292 1.86859 7.32996 4.27476 5.16826 8.15962C3.00656 12.0445 3.12279 16.7963 5.47183 20.5708L1.875 28.125L9.42917 24.5282C13.8465 27.2746 19.5166 26.932 23.5711 23.6736C27.6255 20.4152 29.1801 14.9516 27.4485 10.0468C25.7168 5.14198 21.0765 1.86555 15.875 1.87501Z",
    stroke: "#130B43",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.375 16.75C19.375 18.683 17.808 20.25 15.875 20.25C13.942 20.25 12.375 18.683 12.375 16.75H19.375Z",
    stroke: "#130B43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 11.9375C10.3834 11.9375 10.1875 12.1334 10.1875 12.375C10.1875 12.6166 10.3834 12.8125 10.625 12.8125C10.8666 12.8125 11.0625 12.6166 11.0625 12.375C11.0625 12.1334 10.8666 11.9375 10.625 11.9375",
    stroke: "#130B43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 11.9375C20.8834 11.9375 20.6875 12.1334 20.6875 12.375C20.6875 12.6166 20.8834 12.8125 21.125 12.8125C21.3666 12.8125 21.5625 12.6166 21.5625 12.375C21.5625 12.1334 21.3666 11.9375 21.125 11.9375",
    stroke: "#130B43",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsInner);
export default __webpack_public_path__ + "static/media/testimonials-inner.aeb570cb4a5b194820fd9897fcd078ad.svg";
export { ForwardRef as ReactComponent };